import type { FaireProductEntity } from "../../entity_types/product";

export const p_dvha5vqz7g: FaireProductEntity = {
  token: "p_dvha5vqz7g",
  type: "product",
  name: "Cacti & Succulents",
  brandToken: "b_4ztdnlvzm9",
  brandName: "Eurographics Puzzles USA",
  imageUrl:
    "https://cdn.faire.com/fastly/cdeae56279a3b001a3e83ae793e8a6794aa4e25eb20dcd42a09cf626e86c5335.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/319ea2b69dfdf61945b0ce738ed5fcf96d87543177d8c3471f385093720ddf32.jpeg",
    "https://cdn.faire.com/fastly/09e26fda5c877d491fb59992d66bd6cdbf55812a84ac612824e75e6326baddc5.jpeg",
  ],
  priceDollars: 15.24,
  description:
    'EuroGraphics Cacti & Succulents 1000-Piece Puzzle. Box size: 10" x 14" x 2.37". Finished Puzzle Size: 19.25" x 26.5". Cactus, or plural "cacti" show many adaptations to conserve water. Most species of cacti have lost true leaves, retaining only spines, which are highly modified leaves. Succulent plants, also known as succulents or sometimes fat plants are plants having some parts that are more than normally thickened and fleshy, usually to retain water in arid climates or soil conditions. Ensuring a snug fit and hours of relaxing enjoyment. Premium Quality: Crafted with premium blueboard and a linen finish for a durable, glare-free experience. Eco-Friendly:Manufactured using recycled and responsibly sourced materials.',
  tags: [],
  msrpDollars: 30.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:52.890Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
